import Base from '../../components/base';

const EVENTS = {
	serieToggled: 'serieToggled',
};

const legendItem = (series) => {
	const { colorIndex, options: { name, id, visible, togglable = true } } = series;
	const { userOptions: { className } } = series;
	const colorClass = className ? className : `highcharts-color-${colorIndex}`;

	return `
	<label for="${`serie-${id}`}"class="option-group__item">
		<span class="chart__indicator series-color ${colorClass}"></span>
		${togglable ? `<input type="checkbox" data-serie="${id}" id="serie-${`${id}`}" class="option-group__option" ${visible ? 'checked' : ''}>` : ''}
		${name}
	</label>
`;
};

class Legend extends Base {
	constructor(el, series = []) {
		super(el);

		this.series = series;

		this.on('change');
	}

	get series() {
		return this._series || [];
	}

	set series(s) {
		this._series = s;

		const html = s.reduce((tpl, serie) => {
			tpl = `${tpl}${legendItem(serie)}`;

			return tpl;
		}, '');

		this.render(html);
	}

	onChange(e) {
		const { target: { checked: isVsible, dataset: { serie: serieId } } } = e;

		const event = new CustomEvent(EVENTS.serieToggled, {
			bubbles: true,
			detail: { serieId, isVsible },
		});

		this.el.dispatchEvent(event);
	}

	clear() {
		this.render('');
	}

	render(html = '') {
		this.el.innerHTML = html;
	}
}

export default Legend;

export {
	EVENTS,
};
